// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".employee_note_item:hover{cursor:pointer;background-color:var(--color-cloud-blue)}.employee_note_item:hover .employee_note_item_delete-btn{visibility:visible}.employee_note_item:hover .deleteNoteButton{display:flex;align-items:center}.employee_note_item_delete-btn{visibility:hidden}", ""]);
// Exports
module.exports = exports;
